<template>
    <ui-modal
        dismiss-on="close-button esc"
        ref="modal"
        size="medium"
        title="Log Conversation"
        class="log-message-modal"
    >
        <log-message-pane
            ref="messagePane"
            :default-message-box="defaultMessageBox"
            @saved="$refs.modal.close()"
        />
    </ui-modal>
</template>

<script>
    import LogMessagePane from "./LogConversationPane";

    export default {
        components: { LogMessagePane },
        data() {
            return {
                defaultMessageBox: {}
            }
        },
        methods: {
            open() {
                let messageBox = this.$store.getters['inbox/messageBoxes/all'][0]

                if (this.$route.params.message_box_id) {
                    let currentMessageBox = this.$store.getters['inbox/messageBoxes/all'].find(
                        i => i.id == this.$route.params.message_box_id
                    )

                    if (!currentMessageBox) {
                      currentMessageBox = this.$store.getters['inbox/messageBoxes/first'];
                    }

                    if (currentMessageBox) {
                        this.defaultMessageBox = currentMessageBox
                    }
                }

                this.$nextTick(() => {
                  this.$refs.messagePane.reset()
                })

                this.$refs.modal.open()
            },
        },
        computed: {
            messageDefaults() {
                return {
                    message_box: this.defaultMessageBox
                }
            }
        }

    }
</script>

<style lang="scss">
.log-message-modal {
    .message-quill-editor {
        .ql-container .ql-editor {
            min-height: 200px;
        }
    }

    &.ui-modal--size-medium {
        .ui-modal__container {
            width: 43rem;
        }
    }
}
</style>